import { Component } from 'vue-property-decorator'
import Vue from '@src/vue'
import WorkoutData, { HolderType, WorkoutType } from '@src/data/workout-data'
import EventBus from '@src/lib/event_bus'
import { CreateElement } from 'vue'
import { Tooltip } from '@src/elements/tooltip/tooltip'
import { Icon } from '@src/elements/icon/icon'
import SelectCategories from '@src/routes/content/components/categories/select-categories'
import Member from '@src/data/member'
import { Option } from '@src/elements/select/option'
import { Select } from '@src/elements/select/select'

@Component({
  computed: {
    workout () {
      return this.$store.state.new_workout
    },
    member () {
      // @ts-ignore
      const raw = localStorage.getItem('member')
      let memberStorage = null
      if (raw) {
        try { memberStorage = JSON.parse(raw) } catch (_) { localStorage.removeItem('member') }
      }
      return this.$store.state.trainingMember || memberStorage
    }
  }
})

export class WorkoutTypeSettings extends Vue {

  protected workout: WorkoutData
  protected member: Member | null

  // workout is member or club owned (value to be used to determine the type of workout to be created);
  // if the workout is club owned, and a member is selected, another member owned workout needs to be created
  protected holderType: HolderType = HolderType.CLUB
  private showSelectCategories: boolean = false
  private viewMode = true

  created () {
    this.viewMode = this.$route.path.includes('view')
  }

  render (h: CreateElement) {
    return (
      <template>
        {this.renderTabletOptions(h)}
        <div class='type-switchers'>
          {!this.member && !this.viewMode ?
          <Tooltip content={this.$t('PAGE.CONTENT.WORKOUTS.CATEGORIES.CATEGORIES')} class={`categories ${this.showSelectCategories ? 'selected' : ''}`}>
              <Icon name='workout/categories' click={this.invertShowSelectCategories} />
            </Tooltip> : ''}
          {this.showSelectCategories ? <SelectCategories closeCallback={this.invertShowSelectCategories}/> : ''}
          {this.workout.type === WorkoutType.HOME ? '' :
          <div class='type-switchers'>
            <div class={`type-switcher`}>
              <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.RESTART_WORKOUT')} class={`option ${this.workout.restartIfUncompleted ? 'selected' : ''}`}>
                <Icon name='workout/restart' click={this.setRestartWorkout} />
              </Tooltip>
            </div>
            <div class={`type-switcher ${this.workout.stationLocked ? 'disabled-option' : ''}`}>
              <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.CIRCULAR_WORKOUT')} class={`option ${this.workout.circleWorkout ? 'selected' : ''}`}>
                <Icon name='workout/circle-workout' click={this.setCircleWorkout} />
              </Tooltip>
              {this.workout.stationLocked ?
                <Icon class='option disabled' name='workout/continuous-workout' click={this.setContinuousWorkout} /> :
                <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.CONTINUOUS_WORKOUT')}
                         class={`option ${this.workout.continuousWorkout ? 'selected' : ''}`}>
                  <Icon name='workout/continuous-workout' click={this.setContinuousWorkout} />
                </Tooltip>
              }
              <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.NON_CONTINUOUS_WORKOUT')}
                       class={`option ${(!this.workout.circleWorkout && !this.workout.continuousWorkout) ? 'selected' : ''}`}>
                <Icon name='workout/non-continuous-workout' click={this.setNonContinuousWorkout} />
              </Tooltip>
            </div>
            <div class={`type-switcher ${this.workout.continuousWorkout ? 'disabled-option' : ''}`}>
              {this.workout.continuousWorkout ?
                <Icon class='option disabled' name='workout/station-dependent-workout' click={() => {
                  this.setStationDependence(true)
                }} /> :
                <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.STATION_DEPENDENT_WORKOUT')}
                         class={`option ${this.workout.stationLocked ? 'selected' : ''}`}>
                  <Icon name='workout/station-dependent-workout' click={() => {
                    this.setStationDependence(true)
                  }} />
                </Tooltip>
              }
              <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.STATION_INDEPENDENT_WORKOUT')} class={`option ${!this.workout.stationLocked ? 'selected' : ''}`}>
                <Icon name='workout/station-independent-workout' click={() => {
                  this.setStationDependence(false)
                }} />
              </Tooltip>
            </div>
          </div>}
        </div>
      </template>)
  }

  renderTabletOptions (h: CreateElement) {
    if (this.viewMode) {
      return (<div class={'render-tablet-options'}>
        <Select readonly={this.viewMode} value={this.workout.restartIfUncompleted ? this.$t('PAGE.CONTENT.WORKOUT.RESTART_UNCOMPLETE') : this.$t('PAGE.CONTENT.WORKOUT.NO_RESTART_UNCOMPLETE')} valueChanged={this.setRestartWorkoutbyValue}></Select>
        <Select readonly={this.viewMode} value={this.workout.circleWorkout ? this.$t('PAGE.CONTENT.WORKOUT.CIRCULAR_WORKOUT') : this.workout.continuousWorkout ? this.$t('PAGE.CONTENT.WORKOUT.CONTINUOUS_WORKOUT') : this.$t('PAGE.CONTENT.WORKOUT.NON_CONTINUOUS_WORKOUT')} valueChanged={this.setWorkoutType}></Select>
        <Select readonly={this.viewMode} value={this.workout.stationLocked ? this.$t('PAGE.CONTENT.WORKOUT.STATION_DEPENDENT_WORKOUT') : this.$t('PAGE.CONTENT.WORKOUT.STATION_INDEPENDENT_WORKOUT')} valueChanged={this.setStationDependencebyValue}></Select>
      </div>)
    }
    return (<div class={'render-tablet-options'}>
      <Select readonly={this.viewMode} value={this.$t('PAGE.CONTENT.WORKOUT.WORKOUT_SESSION')} valueChanged={this.setRestartWorkoutbyValue}>
        <Option class={` ${this.workout.restartIfUncompleted && 'selected'}`} type={'single-option'} value={'true'} label={<div class={'mobile-selector'}><Icon name='workout/do-restart'/>{this.$t('PAGE.CONTENT.WORKOUT.RESTART_UNCOMPLETE')}</div>} />
        <Option class={` ${!this.workout.restartIfUncompleted && 'selected'}`} type={'single-option'} value={'false'} label={<div class={'mobile-selector'}><Icon name='workout/do-not-restart'/>{this.$t('PAGE.CONTENT.WORKOUT.NO_RESTART_UNCOMPLETE')}</div>} />
      </Select>
      <Select readonly={this.viewMode} value={this.$t('PAGE.TRAINING_PLAN.FORM.WORKOUT.TYPE')} valueChanged={this.setWorkoutType}>
        <Option class={` ${this.workout.circleWorkout && 'selected'}`} type={'single-option'} value={'circularWorkout'} label={<div class={'mobile-selector'}><Icon name='workout/circle-workout'/>{this.$t('PAGE.CONTENT.WORKOUT.CIRCULAR_WORKOUT')}</div>} />
        {!this.workout.stationLocked && <Option class={` ${this.workout.continuousWorkout && 'selected'}`} type={'single-option'} value={'continuousWorkout'} label={<div class={'mobile-selector'}><Icon name='workout/continuous-workout'/>{this.$t('PAGE.CONTENT.WORKOUT.CONTINUOUS_WORKOUT')}</div>} />}
        <Option class={` ${!this.workout.circleWorkout && !this.workout.continuousWorkout && 'selected'}`} type={'single-option'} value={'nonContinuousWorkout'} label={<div class={'mobile-selector'}><Icon name='workout/non-continuous-workout'/>{this.$t('PAGE.CONTENT.WORKOUT.NON_CONTINUOUS_WORKOUT')}</div>} />
      </Select>
      <Select readonly={this.viewMode} value={this.$t('PAGE.CONTENT.WORKOUT.STATION_DEPENDENCY')} valueChanged={this.setStationDependencebyValue}>
        <Option class={` ${!this.workout.stationLocked && 'selected'}`} type={'single-option'} value={'false'} label={<div class={'mobile-selector'}><Icon name='workout/station-independent-workout'/>{this.$t('PAGE.CONTENT.WORKOUT.STATION_INDEPENDENT_WORKOUT')}</div>} />
        {!this.workout.continuousWorkout && <Option class={` ${this.workout.stationLocked && 'selected'}`} type={'single-option'} value={'true'} label={<div class={'mobile-selector'}><Icon name='workout/station-dependent-workout'/>{this.$t('PAGE.CONTENT.WORKOUT.STATION_DEPENDENT_WORKOUT')}</div>} />}
      </Select>
    </div>)
  }

  setWorkoutType (value) {
    switch (value) {
      case 'continuousWorkout':
        this.setContinuousWorkout()
        break
      case 'circleWorkout':
        this.setCircleWorkout()
        break
      case 'nonContinuousWorkout':
        this.setNonContinuousWorkout()
        break
      default:
        this.setCircleWorkout()
    }
  }

  setCircleWorkout () {
    this.$store.dispatch('setCircleWorkout', true)
    this.workout.circleWorkout = true
    this.$store.dispatch('setContinuousWorkout', false)
    this.workout.continuousWorkout = false
    EventBus.trigger('resetExerciseConfig')
  }

  setContinuousWorkout () {
    if (!this.workout.stationLocked) {
      this.$store.dispatch('setContinuousWorkout', true)
      this.workout.continuousWorkout = true

      this.$store.dispatch('setCircleWorkout', false)
      this.workout.circleWorkout = false
    }
    EventBus.trigger('setExerciseConfigRepetitions')
  }

  setNonContinuousWorkout () {
    this.$store.dispatch('setContinuousWorkout', false)
    this.workout.continuousWorkout = false

    this.$store.dispatch('setCircleWorkout', false)
    this.workout.circleWorkout = false
    EventBus.trigger('setExerciseConfigRepetitions')
  }

  setStationDependence (stationDependence: boolean) {
    if (!this.workout.continuousWorkout) {
      this.$store.dispatch('setStationDependence', stationDependence)
      this.workout.stationLocked = stationDependence
    }
  }

  setStationDependencebyValue (value) {
    let stationDependence = value === 'true'
    if (!this.workout.continuousWorkout) {
      this.$store.dispatch('setStationDependence', stationDependence)
      this.workout.stationLocked = stationDependence
    }
  }

  invertShowSelectCategories () {
    this.showSelectCategories = !this.showSelectCategories
  }

  setRestartWorkout () {
    this.workout.restartIfUncompleted = !this.workout.restartIfUncompleted
    this.$store.dispatch('setRestartWorkout', this.workout.restartIfUncompleted)
  }

  setRestartWorkoutbyValue (value) {
    let restartIfUncompleted = value === 'true'
    this.workout.restartIfUncompleted = restartIfUncompleted
    this.$store.dispatch('setRestartWorkout', this.workout.restartIfUncompleted)
  }
}
